export enum EPageModule {
  TopBar = 'top_bar',
  BottomButton = 'bottom_button',
  Comment = 'comment',
  ArticleMain = 'article_main',
  EndRecommend = 'end_recommend',
  RelatedArticle = 'related_article',
  AuthorInfo = 'author_info',
  AuthorPost = 'author_post',
}
